export default "__VITE_ASSET__CpGT8$kL__"